
import { computed, ref, shallowRef } from '@vue/composition-api';
import { convertBytes } from '~/helper/ConvertBytes';
interface Props {
  disabled?: boolean;
  /**
   * Возможен ли выбор нескольких файлов
   */
  multiple?: boolean;
  /**
   * MIME-форматы, которые можно выбрать в инпуте
   */
  accept?: string;
  /**
   * Максимальный размер картинки (в байтах)
   */
  maxFileSize?: number;
  /**
   * Максимальное количество загружаемых фотографий
   */
  uploadLimit?: number;
}
const __sfc_main = {};
__sfc_main.props = {
  disabled: {
    key: "disabled",
    required: false,
    type: Boolean,
    default: false
  },
  multiple: {
    key: "multiple",
    required: false,
    type: Boolean,
    default: false
  },
  accept: {
    key: "accept",
    required: false,
    type: String,
    default: 'image/*'
  },
  maxFileSize: {
    key: "maxFileSize",
    required: false,
    type: Number,
    default: 5242880
  },
  uploadLimit: {
    key: "uploadLimit",
    required: false,
    type: Number,
    default: 10
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const files = ref<File[]>([]);
  const items = ref<{
    src: string;
    w: number;
    h: number;
  }[] | undefined>([]);
  const photoSwipeIndex = ref(0);
  const openPhotoSwipe = ref(false);
  const photo = shallowRef<HTMLImageElement[]>();
  const images = computed(() => {
    return files.value.map(file => typeof file === 'string' ? file : URL.createObjectURL(file));
  });
  function onClick(index: number) {
    if (items.value) {
      items.value = photo.value?.map(el => {
        return {
          src: el.src,
          w: Number(el.naturalWidth),
          h: Number(el.naturalHeight)
        };
      });
      openPhotoSwipe.value = true;
      photoSwipeIndex.value = index;
    }
  }
  function removeImage(index: number) {
    items.value?.splice(index, 1);
    files.value.splice(index, 1);
    /**
    * Вызывается после удаления картинки
    */
    emit('update', files.value);
  }
  function onFileChange(fileList: File[]) {
    if (!fileList.length) return;

    /**
    * Если количество изображений превышает лимит, отправляем ошибку
    */
    if (files.value.length + fileList.length > props.uploadLimit) {
      emit('error', {
        message: 'Превышено максимальное количество загружаемых фотографий'
      });
      return;
    }

    /**
    * Если размер картинки больше указанного в пропсе, отправляем ошибку
    */
    const isNotMaxFile = fileList.every(file => props.maxFileSize >= file.size);
    isNotMaxFile ? send({
      fileList
    }) : emit('error', {
      message: `Фотография превышает размер ${convertBytes(props.maxFileSize)}`
    });
  }
  function send({
    fileList
  }: {
    fileList: File[];
  }) {
    /**
    * Чтобы при добавление новых фотографий не удалялись старые
    */
    // eslint-disable-next-line prefer-spread
    files.value.push.apply(files.value, fileList);
    /**
    * Вызывается после выбора картинок
    * @property {array} fileList список выбранных файлов напрямую из инпута
    */
    emit('update', files.value);
  }
  function handleFileDrop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    if (files && files.length) {
      const fileList = Array.from(files);
      onFileChange(fileList);
    }
  }
  function handleFileChange(event: Event) {
    const input = (event.target as HTMLInputElement);
    const fileList = input.files;
    if (fileList && fileList.length) {
      const files = Array.from(fileList);
      onFileChange(files);
    }
  }
  return {
    items,
    photoSwipeIndex,
    openPhotoSwipe,
    photo,
    images,
    onClick,
    removeImage,
    handleFileDrop,
    handleFileChange
  };
};
export default __sfc_main;
